module.exports = __webpack_public_path__ + "img/brcj.d39dcb41.png";